import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Modal, Table, Button, Popover, Select , Popconfirm} from 'antd';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import appconstant from '../../../themes/appconstant';
import images from '../../../themes/appImage';
import Textfiled from '../../../common';
import { useDispatch, useSelector } from 'react-redux';
import { activeAdminLoad, adminListLoad, createAdminLoad, deleteAdminLoad } from '../../../redux/slices/admin.slice';
import { emptySpaceInputHandler, hasEmoji } from '../../../utils';
import { debounce } from '../../../utils/global-func';

const resetForm = (formikRef, setModal7Open) => {
  formikRef.setFieldValue("name", "");
  formikRef.setFieldValue("email", "");
  formikRef.setFieldValue("password", "");

  formikRef.setFieldTouched("name", false);
  formikRef.setFieldTouched("email", false);
  formikRef.setFieldTouched("password", false);
  setModal7Open(false);
}

let LIST_LIMIT = 10
let OFFSET = 0
const numberOfRowOptionList = [
  { value: 'one', label: 10 },
  { value: 'two', label: 20 },
  { value: 'three', label: 25 },
]

const Admin = ({ myid }) => {
  const [modal7Open, setModal7Open] = useState(false);
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [currentAdmin, setCurrentAdmin] = useState(null);
  const [popoverVisible, setPopoverVisible] = useState({}); // Adjusted state for popover
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const { adminData, pagination, createAdminSucceeded, isActiveSuccess , isDeleteSuccess } = useSelector((state) => state.adminReducer);
  console.log(isActiveSuccess , isDeleteSuccess , "active Deactive" );

  useEffect(() => {
    if (createAdminSucceeded || isActiveSuccess || isDeleteSuccess) {
      const data = {
        organisation: myid,
        search: "",
        offset: 0,
        limit: 30,
        sort: null,
        order: -1,
      };
      dispatch(adminListLoad(data));
      resetForm(formik, setModal7Open);
    }
  }, [createAdminSucceeded , isActiveSuccess , isDeleteSuccess]);

  

  const handleConfirmStatusChange = () => {
    const data = {
      admin: currentAdmin._id,
    };
    dispatch(activeAdminLoad(data));

    const orgdata = {
      organisation: myid,
    };
    dispatch(adminListLoad(orgdata));

    setStatusModalOpen(false);
    setCurrentAdmin(null);
  };

  const handleDeleteClick = (id) => {
    const data = {
      admin: id,
    };
    dispatch(deleteAdminLoad(data));
    setPopoverVisible({ ...popoverVisible, [id]: false }); // Close popover on delete
  };

  const columnsAdmin = [
    {
      title: 'ID',
      dataIndex: '_id',
      key: '_id',
      sorter: false,
      render: (value, item, index) => index + 1,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: false,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      sorter: false,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      sorter: false,
      render: (value, item) => (
        <div className={`status-${item.isActive ? "active" : "inactive"} cursor-pointer`}>
          <span>{item.isActive ? "Active" : "Inactive"}</span>
        </div>
      ),
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      key: 'actions',
      render: (_, record) => {
        const contentId = `content-${record._id}`;
        const isVisible = popoverVisible[record._id] || false;

        const handleActive = () => {
          const data = {
            admin: record._id,
          };
          dispatch(activeAdminLoad(data));
          setPopoverVisible({ ...popoverVisible, [record._id]: false });
        };

        const handleDelete = () => {
          handleDeleteClick(record._id);
        };

        const popoverContent = (
          <div id={contentId} className="flex flex-col">
            <Popconfirm
              title={`Are you sure you want to ${record.isActive ? "deactivate" : "activate"} this sub admin?`}
              onConfirm={handleActive}
            >
              <Button type="text">
                {record.isActive ? "Deactivate" : "Activate"}
              </Button>
            </Popconfirm>

            <Popconfirm
              title="Are you sure you want to delete this sub admin?"
              onConfirm={handleDelete}
            >
              <Button type="text">Delete</Button>
            </Popconfirm>
          </div>
        );

        return (
          <Popover
            content={popoverContent}
            trigger="click"
            visible={isVisible}
            onVisibleChange={(visible) =>
              setPopoverVisible({ ...popoverVisible, [record._id]: visible })
            }
          >
            <div className="relative action-dots-iocn">
              <span>
                <img src={images.horizontalDots} alt="dots" />
              </span>
            </div>
          </Popover>
        );
      },
    },
  ];

  const inputHandler = (event) => {
    const { name } = event.target;
    formik.setFieldValue(name, emptySpaceInputHandler(event));
  };

  const validationSchema = Yup.object({
    name: Yup.string().trim()
      .min(4, 'Name must be at least 4 characters')
      .matches(/\S+/, 'Name cannot be empty or consist only of spaces')
      .required('Please enter name'),
    email: Yup.string().email('Invalid email address').required('Please enter email'),
    password: Yup.string().min(6, 'Password must be at least 6 characters').required('Please enter password'),
  });

  const formik = useFormik({
    initialValues: {
      name: '',
      email: '',
      password: '',
      organisation: myid,
    },
    validationSchema,
    onSubmit: (values) => {
      dispatch(createAdminLoad({ ...values, name: values.name.trimLeft() }));
    },
  });

  useEffect(() => {
    const data = {
      organisation: myid,
      search: "",
      offset: 0,
      limit: 30,
      sort: null,
      order: -1,
    }
    dispatch(adminListLoad(data));
  }, [myid, dispatch]);

  // Pagination
  const START = useMemo(() => OFFSET + 1, [adminData]);
  const TOTAL_LIST_ITEMS = useMemo(() => pagination?.totalCount, [adminData])
  const END = useMemo(() => (Math.min(OFFSET + LIST_LIMIT, TOTAL_LIST_ITEMS)), [adminData]);
  const canCallNextData = OFFSET + LIST_LIMIT < TOTAL_LIST_ITEMS

  const paginationHandler = useCallback((type) => {
    if (type === "pre") {
      OFFSET = OFFSET - LIST_LIMIT
      const data = {
        offset: OFFSET,
        limit: LIST_LIMIT,
        search: search,
        sort: "createdAt",
        organisation: myid,
        order: -1
      }
      dispatch(adminListLoad(data));
    } else {
      OFFSET = OFFSET + LIST_LIMIT
      const data = {
        offset: OFFSET,
        limit: LIST_LIMIT,
        search: search,
        organisation: myid,
        order: -1
      }
      dispatch(adminListLoad(data));
    }
  }, [adminData])

  const numberOfRowHandler = useCallback((_, dataObj) => {
    LIST_LIMIT = dataObj.label
    OFFSET = 0
    const data = {
      offset: OFFSET,
      limit: LIST_LIMIT,
      search: search,
      organisation: myid,
      order: -1
    }
    dispatch(adminListLoad(data));
  }, [adminData])

  const searchHandler = useCallback((e) => {
    if (emptySpaceInputHandler(e) || e.target.value.length === 0) {
      LIST_LIMIT = 10
      OFFSET = 0
      setSearch(emptySpaceInputHandler(e))
      const data = {
        offset: 0,
        limit: 10,
        search: emptySpaceInputHandler(e).trim(),
        organisation: myid,
        order: -1
      }
      debounce(() => dispatch(adminListLoad(data)))
    }
  }, [adminData]);

  return (
    <div className="content-e outter-space">
      <div className="user-heading">
        <h1>Settings</h1>
        <button onClick={() => setModal7Open(true)}>Add New Admin</button>
      </div>
      <div className="bg-gradient-primary shadow-primary border-radius-lg pt-4 pb-3 system-line">
        <input type="text" value={search} onChange={searchHandler} className="icon-search search-bar" placeholder="Search Admin" />
      </div>
      <div className="admin-table">
        <Table dataSource={adminData} columns={columnsAdmin} showSorterTooltip={false} />
        {TOTAL_LIST_ITEMS > 6 && <div className="footer-section">
          <div className="foot-main-div">
            <div className="rows">
              <div className="row-per-page">
                <p>Rows per page</p>
              </div>
              <div className="top-checkbox fot-select">
                <Select
                  defaultValue={LIST_LIMIT}
                  onChange={numberOfRowHandler}
                  options={numberOfRowOptionList}
                />
              </div>
            </div>

            <div className="page-count">
              <p>{`${START}-${END} of ${TOTAL_LIST_ITEMS}`}</p>
            </div>

            <div className="back-and-next">
              {/* <span><img src={images.back} alt="back" /></span> */}
              <span onClick={() => OFFSET !== 0 && paginationHandler("pre")}><img src={OFFSET == 0 ? images.per : images.paginationDimLeft} style={{ tintColor: "red" }} alt="back" /></span>
              <span onClick={() => canCallNextData && paginationHandler("next")}><img src={canCallNextData == false ? images.paginationDimRight : images.new} alt="back" /></span>
              {/* <span><img src={images.next} alt="back" /></span> */}
            </div>

          </div>

        </div>}
      </div>
      <Modal
        title=""
        className="modal-update"
        centered
        open={modal7Open}
        closable={true}
        onCancel={() => resetForm(formik, setModal7Open)}
        footer={false}
        width={400}
      >
        <div className="add-user-popup">
          <div className="modal-add-user">
            <h1>Add New Admin</h1>
          </div>
          <form onSubmit={formik.handleSubmit}>
            <div className="description-inner-circle">
              <div className="">
                <div className="form-group" style={{ height: "80px" }}>
                  <label>{appconstant.name}</label>
                  <Textfiled
                    className='form-control'
                    type='text'
                    placeholder='Enter your name'
                    name='name'
                    onChange={inputHandler}
                    onBlur={formik.handleBlur}
                    value={formik.values.name}
                  />
                  <div style={{ marginTop: "6px" }}>
                    {formik.touched.name && formik.errors.name ? (
                      <div className="text-red-500 text-xs font-normal">{formik.errors.name}</div>
                    ) : null}
                  </div>
                </div>
                <div className="form-group" style={{ height: "80px" }}>
                  <label>{appconstant.email}</label>
                  <Textfiled
                    className='form-control'
                    type='text'
                    placeholder='Enter your email'
                    name='email'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.email}
                  />
                  <div style={{ marginTop: "6px" }}>
                    {formik.touched.email && formik.errors.email ? (
                      <div className="text-red-500 text-xs font-normal">{formik.errors.email}</div>
                    ) : null}
                  </div>
                </div>
                <div className="form-group" style={{ height: "80px" }}>
                  <label>{appconstant.password}</label>
                  <Textfiled
                    className='form-control'
                    type='password'
                    placeholder='Enter your password'
                    name='password'
                    onChange={inputHandler}
                    onBlur={formik.handleBlur}
                    value={formik.values.password}
                  />
                  <div style={{ marginTop: "6px" }}>
                    {formik.touched.password && formik.errors.password ? (
                      <div className="text-red-500 text-xs font-normal">{formik.errors.password}</div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            <div className="click-to-upload">
              <div className="create-admin">
                <button type="submit">Create</button>
              </div>
            </div>
          </form>
        </div>
      </Modal>
      <Modal
        title="Change Admin Status"
        centered
        open={statusModalOpen}
        onOk={handleConfirmStatusChange}
        onCancel={() => setStatusModalOpen(false)}
        okText={currentAdmin?.isActive ? "Deactivate" : "Activate"}
        cancelText="Cancel"
      >
        <p>Are you sure you want to {currentAdmin?.isActive ? "deactivate" : "activate"} this admin?</p>
      </Modal>
    </div>
  );
};

export default Admin;
